import React from 'react';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { useVppContext } from '@vpp-frontend-components/vpp-context';
import _extends from '@babel/runtime/helpers/extends';
import _jsx from '@babel/runtime/helpers/jsx';
import classNames from 'classnames';
import { onIframeModalResize, trackEvent } from '@vpp-frontend-components/common';
var _br, _hr;
const COMPONENT_TYPE_ACTION = 'action';
const COMPONENT_TYPE_HIGHLIGHT = 'highlighted';
const COMPONENT_TYPE_PILL = 'pill';
const COMPONENT_TYPE_PRICE = 'price';
const COMPONENT_TYPE_MODAL = 'modal';
const COMPONENT_TYPE_BREAKPOINT = 'break';
const COMPONENT_TYPE_SPACE = 'space';
const COMPONENT_TYPE_ICON = 'icon';
const COMPONENT_TYPE_DELETED = 'deleted';
const INTERPOLATION_REGEXP = /{([\s\S]+?)}/g;
const createClickHandler = function (track) {
  let stopPropagation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return event => {
    if (stopPropagation) {
      event.stopPropagation();
    }
    if (track) {
      trackEvent(track);
    }
  };
};

/**
 * @param {string} text
 * @param {object} values
 */
const getJsx = _ref => {
  let {
    text,
    values = {},
    className = '',
    num_font_size = null,
    dependencies = {}
  } = _ref;
  const {
    StyledLabel = () => null,
    Iframe = () => null,
    PriceInline = () => null,
    ActionModal = () => null,
    Icon = () => null
  } = dependencies;
  const getI18nChildren = replacement => {
    var _replacement$i18nChil, _replacement$i18nChil2;
    if (!(replacement !== null && replacement !== void 0 && replacement.i18nChildren)) {
      return null;
    }
    return getJsx({
      text: (_replacement$i18nChil = replacement.i18nChildren) === null || _replacement$i18nChil === void 0 ? void 0 : _replacement$i18nChil.text,
      values: (_replacement$i18nChil2 = replacement.i18nChildren) === null || _replacement$i18nChil2 === void 0 ? void 0 : _replacement$i18nChil2.values,
      dependencies
    });
  };
  const result = text.split(INTERPOLATION_REGEXP);
  for (let index = 0; index < result.length; index += 1) {
    const key = result[index];
    if (Object.prototype.hasOwnProperty.call(values, key)) {
      const replacement = values[key];
      switch (replacement.type) {
        case COMPONENT_TYPE_ACTION:
          result[index] = /*#__PURE__*/_jsx("a", {
            "data-testid": key,
            target: replacement.html_target || '_self',
            onClick: createClickHandler(replacement.track, replacement.stopPropagation),
            href: replacement.target
          }, `${key}-${replacement.target}`, getI18nChildren(replacement) || replacement.label.text, replacement.accessibility_text && /*#__PURE__*/_jsx("span", {
            className: "ui-pdp--hide"
          }, void 0, replacement.accessibility_text));
          break;
        case COMPONENT_TYPE_HIGHLIGHT:
          result[index] = /*#__PURE__*/_jsx(StyledLabel, {
            text: replacement.label.text,
            as: "span",
            className: "ui-pdp-qadb--highlighted"
          }, replacement.label.text);
          break;
        case COMPONENT_TYPE_PILL:
          result[index] = /*#__PURE__*/React.createElement(StyledLabel, _extends({
            key: replacement.text,
            className: "ui-pdp-label-as-pill",
            as: "span"
          }, replacement));
          break;
        case COMPONENT_TYPE_PRICE:
          result[index] = /*#__PURE__*/_jsx(PriceInline, {
            value: replacement.value,
            originalValue: replacement.original_value,
            currencySymbol: replacement.currency_symbol,
            num_font_size: num_font_size || replacement.font_size,
            color: replacement.color,
            font_family: replacement.font_family
          }, key);
          break;
        case COMPONENT_TYPE_MODAL:
          result[index] = /*#__PURE__*/_jsx(ActionModal, {
            label: replacement.label,
            url: replacement.link || replacement.target,
            autoHeight: false,
            modalClassName: classNames('ui-pdp-iframe-modal', replacement.id ? `ui-pdp-${replacement.id}` : null),
            modalUrl: "#pdp-iframe-modal",
            modalTitle: replacement.modal_title,
            closeModalLabel: replacement.close_modal_label,
            className: replacement.classname,
            track: replacement.track
          }, void 0, /*#__PURE__*/_jsx(Iframe, {
            src: replacement.link || replacement.target,
            onMessage: onIframeModalResize('vip:modal-content:loaded', 'height', '.ui-pdp-iframe-modal', '.andes-modal__header', 'width'),
            scrolling: "no"
          }));
          break;
        case COMPONENT_TYPE_ICON:
          result[index] = /*#__PURE__*/React.createElement(Icon, replacement);
          break;
        case COMPONENT_TYPE_BREAKPOINT:
          result[index] = _br || (_br = /*#__PURE__*/_jsx("br", {}));
          break;
        case COMPONENT_TYPE_SPACE:
          result[index] = _hr || (_hr = /*#__PURE__*/_jsx("hr", {
            className: "ui-pdp--highlight-tooltip--space"
          }));
          break;
        case COMPONENT_TYPE_DELETED:
          result[index] = /*#__PURE__*/React.createElement(StyledLabel, _extends({
            key: replacement.text,
            className: className,
            as: "del"
          }, replacement));
          break;
        default:
          result[index] = /*#__PURE__*/React.createElement(StyledLabel, _extends({
            key: key,
            className: className,
            as: "span"
          }, replacement));
      }
    }
  }
  return result;
};
const DependenciesProvider = props => {
  const {
    dependencies
  } = useVppContext();
  return getJsx(_objectSpread(_objectSpread({}, props), {}, {
    dependencies
  }));
};
const componentEnhance = {
  jsx: (text, values, className, num_font_size) => {
    if (!values || Object.keys(values).length === 0) {
      return text;
    }
    return /*#__PURE__*/React.createElement(DependenciesProvider, {
      text,
      values,
      className,
      num_font_size
    });
  }
};
export { componentEnhance };
